import { useTranslation } from 'react-i18next';

import type { OrganizationStatus } from '@nucleus-commerce/api-client/platform';

import { StatusDot, type StatusTone } from '@/shared/ui/status-dot';

const TONES: Record<OrganizationStatus, StatusTone> = {
  active: 'success',
  suspended: 'destructive',
  closed: 'muted',
};

/** Status as a dot + word; colour alone never carries the meaning. */
export function OrganizationStatusBadge({
  status,
  className,
}: {
  status: OrganizationStatus;
  className?: string;
}) {
  const { t } = useTranslation('common');
  return (
    <StatusDot tone={TONES[status]} className={className} data-status={status}>
      {t(`status.${status}`)}
    </StatusDot>
  );
}
